import angular from 'angular';
import { STATES } from '@mover-app/constants';
import { MoveYourStuffConfig } from './move-your-stuff.config';

export const MoveYourStuffModule = angular
  .module(STATES.STEP_MOVE_YOUR_STUFF, [])
  .config(MoveYourStuffConfig);
